export default "__VITE_ASSET__DAuRUf9o__"